@import "../../../../../styles/variables.scss";

qds-button {
  left: 56px;
  position: fixed;

  @media (max-width: 1150px) {
    left: 23px;
  }

  @media (max-width: $uiaas-tablet) {
    display: none;
  }
}
